import { mapDataCloudfrontURL } from "../map/MapConstants";
import { getZippedGeoJson } from "../map/ZippedGeoJsonReader";
import { Source, Layer } from "react-map-gl";
import { useState, useEffect } from "react";
import { emptyGeojson } from "../riskAssessment/defaultSourceLayer";

export const IndigenousLayer: React.FC<{
  active: boolean;
}> = ({ active }) => {
  const [geoJsonData, setGeoJsonData] = useState<GeoJsonData>(emptyGeojson);

  const getIndigenousMap = async (): Promise<GeoJsonData> => {
    const url = `${mapDataCloudfrontURL}mining/cys_data_lacov_bra_gfw_indigenous/cys_data_lacov_bra_gfw_indigenous_rough.zip`;
    return getZippedGeoJson(url);
  };

  useEffect(() => {
    if (active) {
      getIndigenousMap().then((geoJsonRes: GeoJsonData) => {
        setGeoJsonData(geoJsonRes);
      });
    } else {
      setGeoJsonData(emptyGeojson);
    }
  }, [active]);

  return (
    <Source key="indigenous" id="indigenous-src" type="geojson" data={geoJsonData}>
      <Layer
        type="fill"
        paint={{
          "fill-color": "rgb(165, 42, 42)",
          "fill-opacity": 0.3,
        }}
        source="indigenous-src"
        id="indigenous-layer"
      />
    </Source>
  );
};
